export const MskCpf = '###.###.###-##';
export const MskCnpj = '##.###.###/####-##';
export const MskCnpjAlfa = 'XX.XXX.XXX/XXXX-##';
export const MskTelefone = '(##) #####-####';
export const MskMesAno = '##/####';
export const MskCep = '#####-###';

function AplicarMascara(partes, separadores) {
    const valores = partes.filter(Boolean);

    if (valores.length === 0) return '';

    return valores.reduce((formatado, parte, index) => {
        if (index === 0) return parte;
        return `${formatado}${separadores[index - 1]}${parte}`;
    }, '');
}

export function ObterDocumentoLimpo(valor) {
    return (valor || '').toLocaleUpperCase().replace(/[^A-Z0-9]/g, '').substring(0, 14);
}

export function ObterCpfFormatavel(valor) {
    return ObterDocumentoLimpo(valor).replace(/[^0-9]/g, '').substring(0, 11);
}

export function ObterCnpjFormatavel(valor) {
    const documento = ObterDocumentoLimpo(valor);
    const base = documento.substring(0, 12);
    const digitos = documento.substring(12).replace(/[^0-9]/g, '').substring(0, 2);

    return `${base}${digitos}`.substring(0, 14);
}

export function FormatarCnpj(valor) {
    const documento = ObterCnpjFormatavel(valor);
    return AplicarMascara([
        documento.substring(0, 2),
        documento.substring(2, 5),
        documento.substring(5, 8),
        documento.substring(8, 12),
        documento.substring(12, 14)
    ], ['.', '.', '/', '-']);
}

export function FormatarCpfCnpj(valor) {
    const documento = ObterDocumentoLimpo(valor);

    if (/[A-Z]/.test(documento) || documento.length > 11) {
        return FormatarCnpj(documento);
    }

    const digitos = ObterCpfFormatavel(documento);
    return AplicarMascara([
        digitos.substring(0, 3),
        digitos.substring(3, 6),
        digitos.substring(6, 9),
        digitos.substring(9, 11)
    ], ['.', '.', '-']);
}

export default class Global {
    
    constructor(){
        this.mskCpf = MskCpf;
        this.mskCnpj = MskCnpj;
        this.mskCnpjAlfa = MskCnpjAlfa;
        this.mskTelefone = MskTelefone;
        this.mskMesAno = MskMesAno;
        this.mskCep = MskCep;
    }
    
}
